var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStackedBar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "stacked-bar",
  d: "M1 23h23v1H0V0h1z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#stacked-bar"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#435370",
  fillRule: "nonzero",
  xlinkHref: "#stacked-bar"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#435370",
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#4569A5",
  fillRule: "nonzero",
  d: "M10 2v5H3V2zm5 7v5H3V9zm-2 7v5H3v-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#97C2EA",
  fillRule: "nonzero",
  d: "M14 2v5h-3V2zm8 7v5h-6V9zm-8 7h5v5h-5z"
}))));
export default SvgStackedBar;